<script setup>
import { computed } from 'vue';
import ConnectedServicesSectionDW5V2 from './ConnectedServicesSectionDW5V2';

const props = defineProps({
  items: {
    type: Object,
    default: null,
  },
  offerTemplate: {
    type: String,
    default: '',
  },
  isDW5V2: {
    type: Boolean,
    default: false,
  },
  serviceSavingsTexts: {
    type: Object,
    default: null,
  },
});

const checkIfDW5V2 = computed(() => {
  return props.isDW5V2;
});
</script>

<template>
  <ConnectedServicesSectionDW5V2
    v-if="checkIfDW5V2"
    :items="props.items"
    :service-savings-texts="props.serviceSavingsTexts"
  />
</template>

<style scoped>
</style>
